module.exports = __webpack_public_path__ + "img/icon_kehu_05.4d0da0b6.png";